import { Injectable } from '@angular/core';

import { AuthService } from 'src/app/core/auth/auth.service';
import { permissionCodeEnum } from 'src/app/core/permission/permission-code.enum';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private authService: AuthService) {}

  // CUSTOMER ---------------------------------------------------------------------------------

  public canSeeSidenavCustomer(): boolean {
    return (
      this.TestSimpleRightExistence(permissionCodeEnum.AR__CUSTOMER__CAN_LIST_SIMPLE) ||
      this.TestSimpleRightExistence(permissionCodeEnum.AR__CUSTOMER__CAN_LIST_FULL)
    );
  }

  // FEUILLE DE TEMPS ---------------------------------------------------------------------------------

  // afficher le lien FEUILLE DE TEMPS dans le Sidenav ET autorise la route dans le guard
  public canSeeSidenavFdt(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SERVICES__TICKETS__CAN_SEE_TICKETS);
  }

  // TICKET ---------------------------------------------------------------------------------

  // afficher le lien TICKET dans le Sidenav ET autorise la route dans le guard
  public canSeeSidenavTicket(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SERVICES__TICKETS__CAN_SEE_TICKETS);
  }

  // permet de créer des TICKET
  public canCreateTicket(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SERVICES__TICKETS__CAN_CREATE_TICKETS);
  }

  // TICKET TYPE ---------------------------------------------------------------------------------

  public canSeeSidenavTicketType(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SYSTEM__SYSTEM__ADMIN);
  }

  // SERVICE CONTRACT ---------------------------------------------------------------------------------

  // afficher le lien SERVICE CONTRACT dans le Sidenav ET autorise la route dans le guard
  public canSeeSidenavServiceContract(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.AR__SERVICE_CONTRACT__CAN_LIST);
  }

  // SOFTWARE MANAGER ---------------------------------------------------------------------------------

  public canSeeSidenavSoftware(): boolean {
    // TEMPORAIRE custLicencem devrait etre genre SOFTMNGR__SOFTWARE__CAN_LIST_SIMPLE
    return (
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_LIST_SIMPLE) ||
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_LIST_FULL)
    );
  }

  public canCreateSoftware(): boolean {
    return this.TestSimpleRightExistence(
      permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_CREATE // TEMPORAIRE
    );
  }

  public canModifySoftware(): boolean {
    return (
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_MODIFY_BASE) ||
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_MODIFY_FULL)
    );
  }

  // SOFTWARE VERSION ---------------------------------------------------------------------------------

  public canSeeSidenavSoftwareVersion(): boolean {
    return (
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_LIST_SIMPLE) ||
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_LIST_FULL)
    );
  }

  public canCreateSoftwareVersion(): boolean {
    return this.TestSimpleRightExistence(
      permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_CREATE // TEMPORAIRE
    );
  }

  public canModifySoftwareVersion(): boolean {
    return (
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_MODIFY_BASE) ||
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_MODIFY_FULL)
    );
  }

  // SOFTWARE SESSION LOG ---------------------------------------------------------------------------------

  /**
   *  afficher le lien SOFTWARE SESSION LOG dans le Sidenav ET autorise la route dans le guard
   */
  public canSeeSidenavSoftwareLog(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__SOFTLOGS__CAN_LIST);
  }

  // LICENCE ---------------------------------------------------------------------------------

  public canSeeSidenavLicence(): boolean {
    return (
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_LIST_SIMPLE) ||
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_LIST_FULL) ||
      this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_MODIFY_FULL)
    );
  }

  public canCreateLicence(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_CREATE);
  }

  // permet de modifier les valeurs de base
  public canModifyLicenceSimple(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_MODIFY_BASE);
  }

  // permet de modifier les valeurs restreinte à l'admin dans module licence (champs Client, Contrat service, Code logiciel, commentaire)
  public canModifyLicenceFull(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SOFTMNGR__CUSTLICENCE__CAN_MODIFY_FULL);
  }

  // ERP COMPANY CONNECTOR ---------------------------------------------------------------------------------

  public canSeeSidenavConnexionInfo(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SYSTEM__SYSTEM__ADMIN);
  }

  public canCreateConnexionInfo(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SYSTEM__SYSTEM__ADMIN);
  }

  public canModifyConnexionInfo(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SYSTEM__SYSTEM__ADMIN);
  }

  // TASK HISTORY ---------------------------------------------------------------------------------

  /***
   * afficher le lien Task History dans le Sidenav ET autorise la route dans le guard
   * @description //TODO : La permission n'existe pas encore dans backend
   */
  canSeeTaskHistory(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SYSTEM__SYSTEM__ADMIN);
  }

  // USAGER ---------------------------------------------------------------------------------

  // afficher le lien USAGER dans le Sidenav
  public canSeeSidenavUser(): boolean {
    return (
      this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_LIST_SIMPLE) ||
      this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_LIST_FULL)
    );
  }

  // create
  public canCreateUser(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_CREATE);
  }

  // modify
  public canModifyUser(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_MODIFY);
  }

  // permet de modifier les mots de passe
  public canChangePassword(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SYSTEM__SYSTEM__ADMIN);
  }

  // permet de modifier les droits ssager
  public canEditUserRight(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_MANAGE_SECURITY);
  }

  // USER RIGHT ---------------------------------------------------------------------------------

  public canSeeSidenavUserRight(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_MANAGE_SECURITY);
  }

  // ROLE ---------------------------------------------------------------------------------

  public canSeeSidenavRole(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_MANAGE_SECURITY);
  }

  // create
  public canCreateRole(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_MANAGE_SECURITY);
  }

  // modify
  public canModifyRole(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_MANAGE_SECURITY);
  }

  // PRIVILEGE ---------------------------------------------------------------------------------

  public canSeeSidenavPrivilege(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_MANAGE_SECURITY);
  }

  // modify
  public canModifyPrivilege(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SECURITY__USERS__CAN_MANAGE_SECURITY);
  }

  // AUDIT LOG ---------------------------------------------------------------------------------

  // afficher le lien AUDIT LOG dans le Sidenav ET autorise la route dans le guard
  public canSeeSidenavAuditLog(): boolean {
    return this.TestSimpleRightExistence(permissionCodeEnum.SYSTEM__SYSTEM__ADMIN);
  }

  // GLOBAL ---------------------------------------------------------------------------------

  /**
   * Cette fonction retourne true si l'usager courant à la permission (claim) spécifiée
   * @param claimName
   * @returns
   */
  public TestSimpleRightExistence(privilegeToTest: permissionCodeEnum): boolean {
    let TestExist = this.authService.GetCurrentUser().userRightAssignationDTOs?.filter((x) => x.assignedPrivilegeCode == privilegeToTest);
    if (TestExist != null && TestExist.length > 0) return true;
    else return false;
  }
}
